import React, { Component } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { getPosts } from '../../../api/posts';
import AppContext from '../../AppContext';
import { PremiumFeature } from '../../shared/Premium';
import Spinner from '../../shared/Spinner';
import Mosaic from './Mosaic';
import Stats from './Stats';
import UserScoreCards from './UserScoreCards';

export default class CommunityPage extends Component {
  constructor() {
    super();
    this.state = {
      rawPosts: {},
    };
  }

  static contextType = AppContext;
  user = () => this.context.user;
  users = () => this.context.users;

  componentDidMount() {
    getPosts((posts) => {
      this.setState({ rawPosts: posts });
    });
  }

  render() {
    if (!this.user().isPremium) {
      return <PremiumFeature featureName={'Community Page'} />;
    }

    const users = this.users();
    if (!users) {
      return <Spinner size="lg" />;
    }

    return (
      <>
        <Tabs defaultActiveKey="mosaic" className="mt-3">
          <Tab eventKey="mosaic" title="Mosaic">
            <Mosaic />
          </Tab>
          <Tab eventKey="scores" title="Scores">
            <UserScoreCards />
          </Tab>
          <Tab eventKey="stats" title="Stats">
            <Stats posts={this.state.rawPosts} />
          </Tab>
        </Tabs>
      </>
    );
  }
}
